//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { view, getExam, save, cutCreditParty, getResultNum, getFewPartList } from '@/api/jfhl'
import { getintegral, operateCreditlist } from '@/api/user.js'
import config from '@/config'
export default {
  data () {
    return {
      owner_type: config.owner_type,
      partyid: this.$route.params.id || '',
      paperInfoid: '',
      hddesc: '',
      title: '',
      signstartdate: '',
      signenddate: '',
      examList: [],
      subjectid: [],
      useroption: [],
      content: '',
      status: '', // 当前活动时间
      resultObj: {},
      next: false, // 是否显示下一期活动时间
      nextcontent: ''
    }
  },
  computed: {
    accountid () {
      return this.$store.state.user.accountid
    },
    userid () {
      return this.$store.state.user.userid
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      if (this.partyid === '') {
        getFewPartList().then(res => {
          if (res.obj[0].stats === 2 && res.obj.length > 1) {
            this.next = true
            this.partyid = res.obj[1].fewPartyID
            view({// 获取下一期活动时间
              id: res.obj[0].fewPartyID
            }).then(data => {
              this.countDown2(data.obj.signstartdate)
            })
          } else {
            this.partyid = res.obj[0].fewPartyID
          }
          this.getView()
          this.addIntegral() // 进入页面添加积分
        })
      } else {
        this.getView()
        this.addIntegral() // 进入页面添加积分
      }
    },
    // 参加活动加积分
    addIntegral () {
      operateCreditlist({
        accountid: this.accountid,
        rulecode: 'party_rule01',
        credit: 1,
        owner_type: this.owner_type,
        relationtype: 2,
        relationid: 1,
        terminaltype: 2
      }).then(res => { })
    },
    // 活动详情
    getView () {
      view({
        id: this.partyid
      }).then(res => {
        this.paperInfoid = res.obj.paperid
        this.hddesc = res.obj.hddesc
        this.title = res.obj.title
        this.signstartdate = res.obj.signstartdate
        this.signenddate = res.obj.signenddate
        this.countDown(this.signstartdate, this.signenddate)
        if (this.status === 2) {
          this.getResultNum()
        } else {
          this.getExam()
        }
      })
    },
    // 答题详情
    getExam () {
      getExam({
        paperInfoid: this.paperInfoid,
        openid: this.accountid
      }).then(res => {
        this.examList = res.obj.SUBJECTLIST
        this.examList.forEach(element => {
          this.subjectid.push(element.SUBJECTID)
        })
      })
    },
    // 提交
    submit () {
      if (this.useroption.length === 0) {
        this.$vux.toast.text('请先选择答案')
        return
      }
      // 用户总积分
      getintegral({
        accountid: this.accountid,
        owner_type: this.owner_type,
        userid: this.userid
      }).then(res => {
        if (res.returnValue.allnow >= 10) {
          save({
            paperInfoid: this.paperInfoid,
            subjectid: this.subjectid.join(';'),
            useroption: this.useroption.join(';'),
            accountid: this.accountid
          }).then(res => {
            // 参与成功扣除积分
            this.cutCredit(10)
            this.$vux.alert.show({
              content: '参与成功'
            })
          })
        } else {
          this.$vux.alert.show({
            content: '积分不足'
          })
        }
      })
    },
    // 扣除答题需要的积分
    cutCredit (credit) {
      cutCreditParty({
        accoutid: this.accountid,
        credit: credit,
        partyid: this.partyid,
        partytype: 'party'
      })
    },
    getResultNum () {
      getResultNum({
        baseId: this.paperInfoid
      }).then(res => {
        this.resultObj = res.obj
      })
    },
    result () {
      this.$router.push({ name: 'shaoshupaiResult' })
    },
    countDown2 (startDate) {
      let curDate = new Date()
      startDate = new Date(startDate.replace(/-/g, '/'))
      let t = (startDate.getTime() - curDate.getTime()) / 1000
      let timer = setInterval(() => {
        if (t > 0) {
          let day = Math.floor(t / (60 * 60 * 24))
          let hour = Math.floor(t / (60 * 60)) - day * 24
          let minute = Math.floor(t / 60) - day * 24 * 60 - hour * 60
          let second =
            Math.floor(t) - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60

          hour = hour < 10 ? '0' + hour : hour
          minute = minute < 10 ? '0' + minute : minute
          second = second < 10 ? '0' + second : second
          var dayHtml = day > 0 ? `<span>${day}</span> : ` : ''
          this.nextcontent = `${dayHtml}<span>${hour}</span> : <span>${minute}</span> : <span>${second}</span>`
        } else {
          clearInterval(timer)
        }
        t--
      }, 1000)
    },
    countDown (startDate, endDate) {
      let curDate = new Date()
      startDate = new Date(startDate.replace(/-/g, '/'))
      endDate = new Date(endDate.replace(/-/g, '/'))
      let t1 = (startDate.getTime() - curDate.getTime()) / 1000
      if (t1 >= 0) {
        this.content = '未开始'
        this.status = 0
        return false
      }
      let t = (endDate.getTime() - curDate.getTime()) / 1000
      if (t <= 0) {
        this.content = '已结束'
        this.status = 2
        return false
      } else {
        this.status = 1
        let timer = setInterval(() => {
          if (t > 0) {
            let day = Math.floor(t / (60 * 60 * 24))
            let hour = Math.floor(t / (60 * 60)) - day * 24
            let minute = Math.floor(t / 60) - day * 24 * 60 - hour * 60
            let second =
            Math.floor(t) - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60

            hour = hour < 10 ? '0' + hour : hour
            minute = minute < 10 ? '0' + minute : minute
            second = second < 10 ? '0' + second : second
            var dayHtml = day > 0 ? `<span>${day}</span> : ` : ''
            this.content = `${dayHtml}<span>${hour}</span> : <span>${minute}</span> : <span>${second}</span>`
          } else {
            clearInterval(timer)
            this.content = '已结束'
            this.status = 2
          }
          t--
        }, 1000)
      }
    }
  }
}
